export const TYPES = {
    TURNOVER: 'turnoverBonus',
    PAYMENT_TERM: 'paymentTermBonus',
    NETWORK_RETRO_VIP: 'networkRetroBonusVIP',
    NETWORK_RETRO_REDUCER_VIP: 'networkRetroReducerBonusVIP',
    NETWORK_RETRO: 'networkRetroBonus',
    SUPPLEMENTARY_CONTRACTOR: 'supplementaryContractorBonus',
    CLIENT_BUDGET: 'clientBudget',
    CLAIMS_ADJUSTMENTS: 'claimsAdjustments'
}

export const TYPES_DICT = {
    [TYPES.TURNOVER]: 'Premia obrotowa',
    [TYPES.PAYMENT_TERM]: 'Premia terminowe płatności',
    [TYPES.NETWORK_RETRO_VIP]: 'Premia retra sieciowe VIP (naliczona)',
    [TYPES.NETWORK_RETRO_REDUCER_VIP]: 'Premia retra sieciowe VIP (po redukcji)',
    [TYPES.NETWORK_RETRO]: 'Premia retra sieciowe pozostali',
    [TYPES.SUPPLEMENTARY_CONTRACTOR]: 'Premia kontrahent uzupełniający',
    [TYPES.CLIENT_BUDGET]: 'Budżet klienta przyznany w kwartale',
    [TYPES.CLAIMS_ADJUSTMENTS]: 'Reklamacje / doliczenia'
}